import { environment } from '@environments/environment';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { retryWhen } from 'rxjs/operators';
import * as master from '../../assets/master.json';
import {MatTableDataSource} from '@angular/material/table';
import {MatTableModule} from '@angular/material/table';
import { formatDate } from '@angular/common';
import { PaymentService } from '@app/_services/payment.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

export interface masters {
  srno:number;
  subcode: string;
  subname: string;
  marksheetfee: number;
  arearFee: number;
  lateFee: number;
}

@Component({
  selector: 'app-fee-details',
  templateUrl: './fee-details.component.html',
  styleUrls: ['./fee-details.component.less']
})
export class FeeDetailsComponent implements OnInit {

  form: FormGroup;
  JSON;
  console;
  isgPay_url:string;
  todayDate:Date;
  total:any = 0;
  @ViewChild('txnForm') txnForm: any;
  tranxnForm : FormGroup;
  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  commonUtility:CommonUtility;
  loading = false;
  paymentDetails:any='';
  json:any= master;
  source:any;
  amountObj:any;
  installmentNumberList:any;
  feeDetailsList:any[]=[];
  feeTypeAmount:any;
  standardList:any[]=[];
  standardListObj:any[]=[];
  feeType:any;
  submitted = false;
  standard:any;
  installmentNumber:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string;
  BankIdField:string;
  TerminalIdField:string;
  VersionField:string;
  myDIV: Boolean = false ;
  totalDisabled:boolean=true;
  masterData:any;
  dataSource:any;
  toDate:any;
  finalAmount:any;
  split;
  books: any[] = [];
  selectedBooks: any[] = [];
  amount: any;
  bookName:any;
  totalAmount: any;
  captcha:any;
  initialCap: any;

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService
  ) {
    this.JSON=JSON;
    this.isgPay_url = paymentService.isgPay_url;
    this.commonUtility = this.paymentService.commonUtility;
    this.masterData = master;
    this.console = console;
   
   }
   maxValue(event)
   {
    if(event.target.value && event.target.max)
    {
      if((event.which != 8 && event.which != 46 && event.which != 37 &&event.which != 39 &&event.which != 9))
      {
          if(event.target.value.length>(<number>event.target.max-1))
        {
          event.preventDefault();
        }
      }
    }
   }

  ngOnInit(): void {
  this.tranxnForm = this.formBuilder.group({
    Version:[''],
    TerminalId: [''],
    BankId: [''],
    MerchantId: [''],
    EncData:[''],
    TransactionId:['']

         });
      this.form = this.formBuilder.group({
        name: ["",[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]],
        address: ["",[Validators.required]],
        mobileNo: ["",[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]],
        emailId: ["",[Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]],
        bookName: [""],
        amount: [""],
        miscellenousAmount:["",[Validators.pattern("^[0-9]*$")]],
        miscellenousRemarks:[""],
        remarks:[""],
        finalAmount: [{value: '', disabled:true},[Validators.required]],
        captcha : ["", [Validators.required]]  
      });


      // this.http.get('assets/master.json').subscribe((data: any[]) => {
      //   this.books = data;
      // });
        this.http.get('sanskritacademy/assets/master.json').subscribe((data: any) => {
          this.books = data;
          this.books.forEach(book => {
            console.log("Book Name:", book.bookName);
            console.log("Amount:", book.amount);
          });
        });

         this.Cap();
  }

  ValidCaptcha(){
    let str1=this.initialCap
    let str2=this.form.get('captcha').value;
    if(str2.toUpperCase()!="") {
    if(str1 == str2.toUpperCase()){
      this.form.controls['captcha'].setErrors(null);
      return true;
    }else{
      this.form.controls['captcha'].setErrors({'incorrectcaptcha': true});
      return false;
    }
    }
    else {
      this.commonUtility.alertMsg('Please try again invalid Captcha','',false);
    }
  }

  Cap() {
    let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
     var apl1 = alpha[Math.floor(Math.random() * 36)];
     var apl2 = alpha[Math.floor(Math.random() * 36)];
     var apl3 = alpha[Math.floor(Math.random() * 36)];
     var apl4 = alpha[Math.floor(Math.random() * 36)];
     var apl5 = alpha[Math.floor(Math.random() * 36)];
     var apl6 = alpha[Math.floor(Math.random() * 36)];
     this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;

    }

  // calculateTotalAmount() {
  //   this.amount = this.selectedBooks.reduce((total, book) => total + this.bookName.amount, 0);
  // }

  // calculateTotalAmount() {
  //   console.log("In calculateTotalAmount");
  //   this.totalAmount = this.selectedBooks.reduce((total, book) => total + book.amount, 0);
  //   console.log("Total Amount ---",this.totalAmount)
  //   this.form.controls.amount.setValue(this.totalAmount);
  // }

  // calculateTotalAmount() {
  //   console.log("In calculateTotalAmount");
  //   this.totalAmount = this.selectedBooks.reduce((total, bookName) => {
  //     const book = this.books.find(b => b.bookName === bookName);
  //     return book ? total + book.amount : total;
  //   }, 0);

  //   this.form.controls['amount'].setValue(this.totalAmount);
  // }

  calculateTotalAmount() {
    console.log("In calculateTotalAmount");
    this.totalAmount = this.selectedBooks.reduce((total, bookName) => {
      const book = this.books.find(b => b.bookName === bookName);
      return book ? total + book.amount : total;
    }, 0);
    this.form.controls['amount'].setValue(this.totalAmount);
    this.getTotal(); // Update final amount
  }

  get f()
 { return this.form.controls; }

 redirectHome()
 {
   this.router.navigate(['/']);
 }

  Submit():void{

    var routeUrl;
    this.submitted = true;

       if(this.form.controls.finalAmount.value == 0)
       {
         this.commonUtility.alertMsg('Final Amount should not be zero','',false);
       }
       else{

        this.submitted = true;

      if (this.form.invalid || (!this.ValidCaptcha())) {
        return;
      } 
      this.loading = true;

    let req = {

        'name':this.form.controls.name.value.toString(),
        'address': this.form.controls.address.value.toString(),
        'mobileNo': this.form.controls.mobileNo.value.toString(),
        'emailId' : this.form.controls.emailId.value.toString(),
        'bookName' : this.form.controls.bookName.value.toString(),
        'amount': this.form.controls.amount.value.toString(),
        'miscellenousAmount': this.form.controls.miscellenousAmount.value.toString(),
        'miscellenousRemarks': this.form.controls.miscellenousRemarks.value.toString(),
        'remarks': this.form.controls.remarks.value.toString(),
        'finalAmount': this.form.controls.finalAmount.value.toString(),
        'source': 'SANSKRITACADEMY',
        "captcha":this.form.controls.captcha.value

    }

    const encodedCaptcha = btoa(this.form.controls.captcha.value);
    //console.log("Encoded CAPTCHA--",encodedCaptcha);     
    //console.log("On Submit Req-------",req); 
    routeUrl = 'payment/pay-details';

    this.paymentService.submitSanskritAcademyDetails(req,encodedCaptcha).subscribe(res =>  {
      if(res.body.statusCode === "00000")
      {

       this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
       this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
       this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
       this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
       this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
       this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

       this.EncDataField  	= res.body.data.fields.EncData;
       this.MerchantIdField = res.body.data.fields.MerchantId;
       this.BankIdField = res.body.data.fields.BankId;
       this.TerminalIdField = res.body.data.fields.TerminalId ;
       this.VersionField = res.body.data.fields.Version ;
       this.txnForm.nativeElement.submit();


      }
      else{
       this.commonUtility.alertMsg(res.body.statusDesc,'',false);
      }
      this.Cap();
       this.loading = false;
            },(error)=>
            { this.Cap();
            this.commonUtility.alertMsg(JSON.stringify(error.statusText) ,'',false);}
      )
     }
    }

    getTotal() {
      this.finalAmount
      let amount = this.form.get('amount').value;
      let miscellenousAmount = this.form.get('miscellenousAmount').value;
    
      this.finalAmount =0;
      if(amount)
      {
        this.finalAmount = Number(this.finalAmount +parseInt(amount));
      }
      if(miscellenousAmount)
      {
        this.finalAmount= Number(this.finalAmount +parseInt(miscellenousAmount));
      }
    
      console.log("number"+this.finalAmount);
        if(Number(this.finalAmount)>0)
        
        { this.totalDisabled=false;

        }
        else{
          this.totalDisabled=true;
        }
        console.log(this.totalDisabled);
        this.form.updateValueAndValidity()

        this.form.controls.finalAmount.setValue(this.finalAmount);
        this.form.controls.finalAmount.updateValueAndValidity();

    }


  onSubmit(): void
{

}

hideError(controlName:any)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }

    }
}
 